/* Assets/delivery-checker.js */

document.addEventListener('DOMContentLoaded', function() {
  
  // =========================================================
  // 1. DATA CONFIGURATION
  // =========================================================
  
  // PASTE YOUR FRESH/LOCAL POSTCODES HERE
  const localPostcodes = [
    "5006","5031","5069","5070","5082","5087","5032","5083","5022","5007","5081","5073","5052","5062","5041","5042","5051","5050","5064","5039","5063","5061","5034","5035","5000","5066","5045","5068","5033","5067","5049","5038","5037","5047","5065","5046","5043","5044","5048","5140","5040","5001","5156","5020","5072","5152","5016","5019","5020","5015","5021","5095","5074","5097","5092","5086","5091","5085","5075","5089","5088","5014","5094","5093","5098","5076","5134","5012","5013","5017","5018","5090","5125","5126","5109","5106","5108","5096","5127","5112","5114","5011","5083","5107","5115","5157","5136","5151","5154","5155","5142","5245","5243","5152","5144","5251","5156","5137","5242","5138","5240","5250","5241","5153","5141","5244","5942","5087","5011","5084","5010","5024","5009","5025","5008","5023","5950","5159","5167","5161","5165","5168","5166","5158","5162","5163","5160","5164","5169","5173","5170","5172","5174","5171"
  ];

  // PASTE YOUR FREEZE/SHIP POSTCODES HERE
  const shippingPostcodes = [
    "5290","5600","5700","5540","5253","5606","5118","5211","5302","5341","5271","5343","5554","5453","5725","5333","5280","5355","5352","5268","5373","5223","5238","5680","5330","5422","5491","5605","5203","5723","5212","5213","5214","5210","5272","5641","5153","5141","5144","5142","5252","5116","5171","5244","5251","5243","5250","5245","5155","5138","5150","5154","5242","3000","3002","3003","3006","3008","3051","3052","3053","3055","3056","3057","3058","3060","3070","3071","3072","3073","3076","3047","3101","3103","3108","3122","3124","3125","3128","3131","3134","3149","3150","3182","3184","3186","3189","3191","3192","3194","3199","3011","3013","3018","3020","3029","3030","3280","3040","3039","3044","3046","3064","3127","3132","3133","3140","3136","3805","3806","3977","3023","3038","3337","3220","3350","3550","3630","3500","3690","3844","3825","3840","3677","3850","3875","3250","3305","3377","3585","3300","3400","3465","3953","3672","3764","3450","3437","3228","3233","2000","2007","2008","2009","2010","2011","2015","2016","2017","2019","2021","2022","2023","2024","2026","2031","2032","2034","2035","2036","2037","2041","2042","2044","2045","2046","2048","2049","2050","2052","2055","2057","2060","2061","2064","2065","2066","2067","2068","2069","2070","2071","2072","2073","2074","2075","2076","2077","2079","2080","2081","2082","2083","2084","2085","2086","2087","2088","2089","2090","2093","2094","2095","2096","2099","2100","2101","2102","2103","2104","2105","2106","2107","2108","2109","2110","2111","2112","2113","2114","2115","3227","3004","3005","3010","3012","3015","3016","3019","3021","3022","3024","3025","3026","3027","3028","3031","3032","3033","3034","3036","3037","3041","3042","3043","3045","3048","3049","3050","3054","3059","3061","3062","3063","3065","3066","3067","3068","3074","3075","3078","3079","3081","3082","3083","3084","3085","3087","3088","3089","3090","3091","3093","3094","3095","3096","3097","3099","3102","3104","3105","3106","3107","3109","3111","3113","3114","3115","3116","3121","3123","3126","3129","3130","3135","3137","3138","3139","3141","3142","3143","3144","3145","3146","3147","3148","3151","3152","3153","3154","3155","3156","3158","3159","3160","3161","3162","3163","3165","3166","3167","3168","3169","3170","3171","3172","3173","3174","3175","3177","3178","3179","3180","3181","3183","3185","3187","3188","3190","3193","3195","3196","3197","3198","3200","3201","3202","3204","3205","3206","3207","3211","3212","3214","3215","3216","3217","3218","3219","3221","3222","3223","3224","3225","3226","3230","3231","3232","3234","3235","3236","3237","3238","3239","3240","3241","3242","3243","3249","3251","3254","3260","3264","3265","3266","3267","3268","3269","3270","3271","3272","3273","3274","3275","3276","3277","3278","3279","3281","3282","3283","3284","3285","3286","3287","3289","3293","3294","3301","3302","3303","3304","3309","3310","3311","3312","3314","3315","3317","3318","3319","3321","3322","3323","3324","3325","3328","3329","3330","3331","3332","3333","3334","3335","3338","3340","3341","3342","3345","3351","3352","3353","3354","3355","3356","3357","3360","3361","3363","3364","3365","3366","3367","3368","3370","3371","3373","3374","3375","3378","3379","3380","3381","3384","3385","3387","3388","3390","3391","3392","3393","3395","3396","3401","3402","3407","3409","3412","3413","3414","3415","3418","3419","3420","3423","3424","3427","3428","3429","3430","3431","3432","3433","3434","3435","3438","3440","3441","3442","3444","3446","3447","3448","3451","3453","3458","3460","3461","3462","3463","3464","3467","3468","3469","3472","3475","3477","3478","3479","3480","3482","3483","3485","3487","3488","3489","3490","3491","3494","3496","3498","3501","3505","3506","3507","3509","3512","3515","3516","3517","3518","3520","3521","3522","3523","3525","3527","3529","3530","3531","3533","3537","3540","3542","3544","3546","3549","3551","3556","3557","3558","3561","3562","3563","3564","3565","3566","3567","3570","3571","3572","3573","3575","3576","3579","3580","3581","3583","3584","3586","3588","3589","3590","3591","3594","3595","3596","3597","3599","3607","3610","3612","3614","3616","3617","3618","3620","3621","3622","3623","3624","3629","3631","3633","3634","3635","3636","3637","3638","3640","3641","3644","3646","3647","3649","3658","3659","3660","3662","3663","3664","3665","3666","3669","3670","3673","3675","3676","3678","3682","3683","3685","3687","3688","3689","3691","3695","3697","3698","3699","3700","3701","3704","3705","3707","3708","3709","3711","3712","3713","3714","3715","3717","3718","3719","3720","3722","3723","3725","3726","3727","3728","3730","3732","3733","3735","3737","3738","3739","3740","3741","3744","3746","3747","3749","3750","3751","3752","3753","3754","3755","3756","3757","3758","3759","3760","3761","3762","3763","3765","3766","3767","3770","3775","3777","3778","3779","3781","3782","3783","3785","3786","3787","3788","3789","3791","3792","3793","3795","3796","3797","3799","3802","3803","3804","3807","3808","3809","3810","3812","3813","3814","3815","3816","3818","3820","3821","3822","3823","3824","3831","3832","3833","3835","3842","3847","3851","3852","3854","3856","3857","3858","3859","3860","3862","3864","3865","3869","3870","3871","3873","3874","3878","3880","3882","3885","3886","3887","3888","3889","3890","3891","3892","3893","3895","3896","3898","3900","3902","3903","3904","3909","3910","3911","3912","3913","3915","3916","3918","3919","3920","3921","3922","3923","3925","3926","3927","3928","3929","3930","3931","3933","3934","3936","3937","3938","3939","3940","3941","3942","3943","3944","3945","3946","3950","3951","3954","3956","3957","3958","3959","3960","3962","3964","3971","3975","3976","3978","3979","3980","3981","3984","3987","3988","3990","3991","3992","3995","3996","3173","3175","4670","5454","2097","2230","2229","2228","2227","2224","2232","2233","2650","7173","7009","5558","5277","7000","7002","7004","7005","7006","7007","7008","7010","7011","7012","7015","7016","7018","7019","7020","7025","7030","7031","7050","7052","7053","7054","7055","7170","7171","3210","3244","3245","3246","3247","3248","3252","3253","3255","3256","3257","3258","3259","3261","3262","3263","3288","3290","3291","3292","3295","3296","3297","3298","3299","3313","3316","3320","3326","3327","3336","3339","3343","3344","3358","3362","3369","3372","3376","3382","3383","3386","3389","3394","3397","3398","3399","3403","3404","3405","3406","3408","3410","3411","3416","3417","3421","3422","3425","3426","3436","3439","3443","3445","3449","3452","3454","3455","3456","3457","3459","3466","3470","3471","3473","3474","3476","3481","3484","3486","3492","3493","3495","3497","3499","3502","3503","3504","3508","3510","3511","3513","3514","3519","3524","3526","3528","3532","3534","3535","3536","3538","3539","3541","3543","3545","3547","3548","3552","3553","3554","3555","3559","3560","3568","3569","3574","3577","3578","3582","3587","3592","3593","3598","3608","3609","3611","3613","3615","3619","3625","3626","3627","3628","3632","3639","3642","3643","3645","3648","3650","3651","3652","3653","3654","3655","3656","3657","3661","3667","3668","3671","3674","3679","3680","3681","3684","3686","3692","3693","3694","3696","3702","3703","3706","3710","3716","3721","3724","3729","3731","3734","3736","3742","3743","3745","3748","2092","2098","2116","2117","2118","2119","2120","2121","2122","2123","2124","2125","2126","2127","2128","2129","2130","2131","2132","2133","2134","2135","2136","2137","2138","2139","2140","2141","2142","2143","2144","2145","2146","2147","2148","2149","2150","2151","2152","2153","2154","2155","2156","2157","2158","2159","2160","2161","2162","2163","2164","2165","2166","2167","2168","2169","2170","2171","2172","2173","2174","2175","2176","2177","2178","2179","2180","2190","2191","2192","2193","2194","2195","2196","2197","2198","2199","2200","2203","2204","2205","2206","2207","2208","2209","2210","2211","2212","2213","2214","2216","2217","2218","2219","2220","2221","2222","2223","2225","2226","2231","2234","2235","2236","2237","2238","2239","2240","2241","2242","2243","2244","2245","2246","2247","2248","2249","2250","2251","2252","2253","2254","2255","2256","2257","2258","2259","2260","2261","2262","2263","2264","2265","2266","2267","2268","2269","2270","2271","2272","2273","2274","2275","2276","2277","2278","2279","2280","2281","2282","2283","2284","2285","2286","2287","2288","2289","2290","2291","2292","2293","2294","2295","2296","2297","2298","2299","2300","2301","2302","2303","2304","2305","2306","2307","2308","2309","2310","2311","2312","2313","2314","2315","2316","2317","2318","2319","2320","2321","2322","2323","2324","2325","2326","2327","2328","2329","2330","2331","2332","2333","2334","2335","2336","2337","2338","2339","2340","2341","2342","2343","2344","2345","2346","2347","2348","2349","2350","2351","2352","2353","2354","2355","2356","2357","2358","2359","2360","2361","2365","2369","2370","2371","2372","2379","2380","2381","2382","2386","2388","2390","2395","2396","2397","2398","2400","2401","2402","2403","2404","2405","2406","2408","2409","2410","2411","2415","2420","2421","2422","2423","2424","2425","2426","2427","2428","2429","2430","2431","2439","2440","2441","2442","2443","2444","2445","2446","2447","2448","2449","2450","2452","2453","2454","2455","2456","2460","2462","2463","2464","2465","2466","2469","2470","2471","2472","2473","2474","2475","2476","2477","2478","2479","2480","2481","2482","2483","2484","2485","2486","2487","2488","2489","2490","2500","2502","2505","2506","2508","2515","2516","2517","2518","2519","2525","2526","2527","2528","2529","2530","2533","2534","2535","2536","2537","2538","2539","2540","2541","2545","2546","2548","2550","2551","2555","2556","2557","2558","2559","2560","2563","2564","2565","2566","2567","2568","2569","2570","2571","2572","2573","2574","2575","2576","2577","2578","2579","2580","2581","2582","2583","2584","2585","2586","2587","2588","2590","2594","2599","2600","2601","2602","2603","2604","2605","2606","2607","2608","2609","2610","2611","2612","2614","2615","2616","2617","2618","2619","2620","2621","2622","2623","2624","2625","2626","2627","2628","2629","2630","2631","2632","2633","2634","2635","2636","2637","2638","2639","2640","2641","2642","2643","2644","2645","2646","2647","2648","2649","2651","2652","2653","2654","2655","2656","2657","2658","2659","2660","2661","2662","2663","2664","2665","2666","2667","2668","2669","2670","2671","2672","2675","2678","2680","2681","2682","2683","2684","2685","2686","2687","2688","2689","2690","2691","2692","2693","2694","2695","2696","2697","2698","2699","2700","2701","2702","2703","2704","2705","2706","2707","2708","2709","2710","2711","2712","2713","2714","2715","2716","2717","2718","2719","2720","2721","2722","2723","2724","2725","2726","2727","2728","2729","2730","2731","2732","2733","2734","2735","2736","2737","2738","2739","2740","2741","2742","2743","2744","2745","2746","2747","2748","2749","2750","2751","2752","2753","2754","2755","2756","2757","2758","2759","2760","2761","2762","2763","2764","2765","2766","2767","2768","2769","2770","2771","2772","2773","2774","2775","2776","2777","2778","2779","2780","2782","2783","2784","2785","2786","2787","2790","2791","2792","2793","2794","2795","2796","2797","2798","2799","2800","2803","2804","2805","2806","2807","2808","2809","2810","2817","2820","2821","2822","2823","2824","2825","2826","2827","2828","2829","2830","2831","2832","2833","2834","2835","2836","2837","2838","2839","2840","2842","2843","2844","2845","2846","2847","2848","2849","2850","2852","2853","2854","2855","2856","2857","2858","2859","2860","2864","2865","2866","2867","2868","2869","2870","2871","2873","2874","2875","2876","2877","2878","2879","2880","7001","7003","7013","7014","7017","7022","7023","7024","7026","7027","7028","7032","7033","7034","7035","7036","7037","7038","7039","7040","7041","7042","7043","7044","7045","7046","7047","7048","7049","7051","7056","7057","7058","7059","7060","7061","7062","7063","7064","7065","7066","7067","7068","7069","7070","7071","7072","7073","7074","7075","7076","7077","7078","7079","7080","7081","7082","7083","7084","7085","7086","7087","7088","7089","7090","7091","7092","7093","7094","7095","7096","7097","7098","7099","7100","7101","7109","7110","7112","7113","7116","7117","7119","7120","7126","7130","7139","7140","7145","7150","7155","7160","7172","7174","7175","7176","7177","7178","7179","7180","7182","7183","7184","7185","7186","7187","7188","7189","7190","7200","7201","7209","7210","7211","7212","7213","7214","7215","7216","7217","7218","7219","7220","7221","7248","7249","7250","7252","7253","7254","7255","7256","7257","7258","7259","7260","7261","7262","7263","7264","7265","7266","7267","7268","7269","7270","7275","7276","7277","7278","7279","7280","7290","7291","7292","7300","7301","7302","7303","7304","7305","7306","7307","7308","7310","7315","7316","7320","7321","7322","7325","7330","7331","7332","7333","7334","7335","7336","7337","7338","7339","7340","7341","7342","7343","7344","7345","7346","7347","7348","7349","7350","7351","7352","7353","7354","7355","7356","7357","7358","7359","7360","7361","7362","7363","7364","7365","7366","7367","7368","7369","7370","7371","7372","7373","7374","7375","7376","7377","7378","7379","7380","7381","7382","7383","7384","7385","7386","7387","7388","7389","7390","7391","7392","7393","7394","7395","7396","7397","7398","7399","7400","7401","7402","7403","7404","7405","7406","7407","7408","7409","7410","7411","7412","7413","7414","7415","7416","7417","7418","7419","7420","7421","7422","7423","7424","7425","7426","7427","7428","7429","7430","7431","7432","7433","7434","7435","7436","7437","7438","7439","7440","7441","7442","7443","7444","7445","7446","7447","7448","7449","7450","7451","7452","7453","7454","5240","5241","5602","5603","5604","5607","5611","5612","5631","5632","5633","5634","5637","5638","5640","5650","5651","5652","5653","5654","5655","5660","5661","5662","5663","5670","5671","5672","5681","5690","5701","5710","5720","5722","5730","5731","5732","5733","5734","5739","5740","5741","5742","5745","5750","5751","5752","5753","5754","5755","5756","5757","5758","5759","5760","5761","5762","5763","5764","5765","5766","5767","5768","5769","5770","5771","5772","5773","5774","5780","5790","5800","5810","5820","5830","5840","5850","5860","5870","5880","5890"
  ];
  
  // Expose arrays globally for menu-shop-dropdown
  window.dcLocalPostcodes = localPostcodes;
  window.dcShippingPostcodes = shippingPostcodes;

  // =========================================================
  // 2. DOM ELEMENTS
  // =========================================================
  const formPanel = document.getElementById('dc-form-panel');
  const statusPanel = document.getElementById('dc-status-panel');
  const statusText = document.getElementById('dc-status-text');
  
  const checkBtn = document.getElementById('deliveryCheckBtn');
  const pickupBtn = document.getElementById('pickupBtn');
  const changeBtn = document.getElementById('dc-change-btn');
  
  const inputField = document.getElementById('deliveryPostcode');
  const messageArea = document.getElementById('deliveryMessage');

  const headerWidget = document.getElementById('header-delivery-widget');
  const headerText = headerWidget ? headerWidget.querySelector('.header-delivery-text') : null;
  const headerIcon = document.querySelector('.header-delivery-icon');
  const headerTrigger = document.getElementById('header-delivery-trigger');
  const headerPopover = document.getElementById('header-delivery-popover');
  const headerInput = document.getElementById('headerDeliveryPostcode');
  const headerCheckBtn = document.getElementById('headerDeliveryCheckBtn');
  const headerMessage = document.getElementById('header-delivery-message');

  // =========================================================
  // 3. CORE LOGIC & STORAGE
  // =========================================================
  
  // Run immediately on load
  init();

  function init() {
    const savedData = localStorage.getItem('dc_preference');
    if (savedData) {
      // Data found: Hide form, Show status, Filter products
      const data = JSON.parse(savedData);
      applyUIState('STATUS', data);
      runFilter(data.tag);
    } else {
      // No Data: Show form
      applyUIState('FORM');
      
      // Safety: Ensure header popover is closed on fresh load
      const hp = document.getElementById('header-delivery-popover');
      if(hp) hp.classList.remove('is-open');
    }
  }

  function savePreference(type, value, tag, displayText) {
    const data = {
      type: type, // 'DELIVERY' or 'PICKUP'
      value: value, // Postcode or 'PICKUP'
      tag: tag, // 'service-local', 'service-ship', or 'RESET'
      text: displayText // Text to show in the status bar
    };
    localStorage.setItem('dc_preference', JSON.stringify(data));
    
    // Update UI immediately
    applyUIState('STATUS', data);
    runFilter(tag);
    
    // Sync with Zapiet immediately
    syncWithZapiet(data);
    
    // Dispatch custom event for collection auto-switch
    window.dispatchEvent(new CustomEvent('dcPreferenceChanged', { detail: data }));
  }

  function clearPreference() {
    localStorage.removeItem('dc_preference');
    applyUIState('FORM');
    runFilter('RESET'); // Show everything when resetting
    if(inputField) inputField.value = ''; // Clear input
    if(messageArea) messageArea.innerText = ''; // Clear old messages
    const notifyContainer = document.getElementById('dc-notification-container');
    if(notifyContainer) notifyContainer.style.display = 'none';
    
    // Dispatch custom event to reset collection
    window.dispatchEvent(new CustomEvent('dcPreferenceChanged', { detail: null }));
  }

  function applyUIState(state, data = null) {
    if (state === 'STATUS' && data) {
      if(formPanel) formPanel.style.display = 'none';
      if(statusPanel) statusPanel.style.display = 'flex'; // Flex for layout
      
      // Update Main Status Bar
      if(statusText) statusText.innerHTML = data.text;
      
      // Update Header Widget
      if(headerText) {
         let locationStr = "";
         if(data.type === 'PICKUP') {
             locationStr = "Location: Pickup";
         } else {
             locationStr = "Location: " + data.value; 
         }
         
         headerText.innerHTML = `${locationStr} <span style="text-decoration: underline; margin-left: 5px; cursor: pointer; opacity: 0.8 !important; pointer-events: auto;">Change</span>`;
      }
      // Update icon state: Set = Green, No Pulse
      if(headerIcon) {
          headerIcon.classList.remove('dc-waiting');
          headerIcon.classList.add('dc-set');
      }
      
      // 
      // Close popover if open
      if (typeof closeHeaderPopover === 'function') {
        closeHeaderPopover();
      } else {
        const hp = document.getElementById('header-delivery-popover');
        if(hp) hp.classList.remove('is-open');
      }

    } else {
      if(formPanel) formPanel.style.display = 'block';

      // Close popover to ensure clean state
      if (typeof closeHeaderPopover === 'function') {
        closeHeaderPopover();
      } else {
        const hp = document.getElementById('header-delivery-popover');
        if(hp) hp.classList.remove('is-open');
      }
      if(statusPanel) statusPanel.style.display = 'none';
      
      // Clear Header Widget
      if(headerText) headerText.innerText = "Set your delivery location";
      
      // Update icon state: Waiting = Red Pulse
      if(headerIcon) {
        headerIcon.classList.remove('dc-set');
        headerIcon.classList.add('dc-waiting');
      }
    }
  }

  // --- FILTER FUNCTION ---
  function runFilter(mode) {
    const hooks = document.querySelectorAll('.product-card-tag-hook');
    
    // Map to group grid items by their container (UL)
    const grids = new Map();

    hooks.forEach(hook => {
        // Find the actual grid item (LI) and container (UL)
        const gridItem = hook.closest('.grid__item');
        if(!gridItem) return;
        
        const container = gridItem.parentNode;
        if(!grids.has(container)) grids.set(container, []);
        
        // Store reference to hook and item
        grids.get(container).push({ hook, gridItem });
    });

    // Process each grid
    grids.forEach((items, container) => {
        const available = [];
        const unavailable = [];

        items.forEach(({ hook, gridItem }) => {
            // Reset base state on the visual card (the hook)
            hook.classList.remove('product-unavailable');
            
            // Get tags from data attribute (more robust than classList)
            const tagString = hook.getAttribute('data-dc-tags') || "";
            const tags = tagString.trim().split(/\s+/); // Split by whitespace

            let isAvailable = true;

            if (mode === 'service-both') {
                // Show products that have EITHER service-local OR service-ship
                if ( !tags.includes('service-local') && !tags.includes('service-ship') ) {
                    isAvailable = false;
                }
            }
            else if (mode === 'service-local') {
                if ( !tags.includes('service-local') ) {
                    isAvailable = false;
                }
            } 
            else if (mode === 'service-ship') {
                if ( !tags.includes('service-ship') ) {
                    isAvailable = false;
                }
            }
            // If mode is RESET or PICKUP, everything is available (isAvailable=true)

            if (!isAvailable) {
                hook.classList.add('product-unavailable');
                unavailable.push(gridItem);
            } else {
                available.push(gridItem);
            }
        });

        // Reorder DOM
        // Append available first, then unavailable
        available.forEach(el => container.appendChild(el));
        unavailable.forEach(el => container.appendChild(el));
    });
  }

  // =========================================================
  // 4. EVENT LISTENERS
  // =========================================================

  // EVENT: Check Delivery Postcode
  if(checkBtn) {
    checkBtn.addEventListener('click', function() {
      const userCode = inputField.value.trim();
      const notifyContainer = document.getElementById('dc-notification-container');
      
      // Reset generic UI bits
      if(notifyContainer) notifyContainer.style.display = 'none';
      messageArea.innerText = '';
      
      if (!userCode) {
        messageArea.innerText = "Please enter a postcode.";
        messageArea.style.color = "red";
        return;
      }

      const isLocal = localPostcodes.includes(userCode);
      const isShipping = shippingPostcodes.includes(userCode);

      if (isLocal && isShipping) {
        // Both Fresh/Local AND Freeze/Ship available
        savePreference('DELIVERY', userCode, 'service-both', `Fresh & Frozen available to: <strong>${userCode}</strong>`);
      }
      else if (isLocal) {
        // Fresh / Local only
        savePreference('DELIVERY', userCode, 'service-local', `Delivering Fresh to: <strong>${userCode}</strong>`);
      } 
      else if (isShipping) {
        // Freeze / Ship only
        savePreference('DELIVERY', userCode, 'service-ship', `Shipping Freeze Items to: <strong>${userCode}</strong>`);
      } 
      else {
        messageArea.innerText = "Sorry, we don't deliver to this postcode.";
        messageArea.style.color = "#c62828";
        
        // Reveal notification form
        if(notifyContainer) {
            notifyContainer.style.display = 'block';
            const bodyInput = document.getElementById('ContactForm-body');
            if(bodyInput) bodyInput.value = `Notify me when delivery is available for postcode: ${userCode}`;
        }
      }
    });
  }

  // EVENT: Pickup
  if(pickupBtn) {
    pickupBtn.addEventListener('click', function() {
      savePreference('PICKUP', 'PICKUP', 'RESET', `Viewing Menu for: <strong>Store Pickup</strong>`);
    });
  }

  // EVENT: Change Location (Reset)
  if(changeBtn) {
    changeBtn.addEventListener('click', function() {
      clearPreference();
    });
  }

  // =========================================================
  // 5. HEADER WIDGET LOGIC
  // =========================================================

  if (headerTrigger) {
    headerTrigger.addEventListener('click', function(e) {
      e.stopPropagation();
      if(headerPopover) headerPopover.classList.toggle('is-open');
    });
  }

  // Close popover when clicking outside
  document.addEventListener('click', function(e) {
    if (headerPopover && headerPopover.classList.contains('is-open')) {
      if (headerWidget && !headerWidget.contains(e.target)) {
        headerPopover.classList.remove('is-open');
      }
    }
  });

  if (headerCheckBtn) {
    headerCheckBtn.addEventListener('click', function() {
        validateHeaderPostcode();
    });
  }

  if (headerInput) {
    headerInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
            validateHeaderPostcode();
        }
    });
  }

  function validateHeaderPostcode() {
      if(!headerInput) return;
      
      const userCode = headerInput.value.trim();
      
      if(headerMessage) headerMessage.innerText = '';

      if (!userCode) {
        if(headerMessage) headerMessage.innerText = "Enter postcode";
        return;
      }

      const isLocal = localPostcodes.includes(userCode);
      const isShipping = shippingPostcodes.includes(userCode);

      if (isLocal && isShipping) {
        // Both Fresh/Local AND Freeze/Ship available
        savePreference('DELIVERY', userCode, 'service-both', `Fresh & Frozen available to: <strong>${userCode}</strong>`);
        closeHeaderPopover();
      }
      else if (isLocal) {
        savePreference('DELIVERY', userCode, 'service-local', `Delivering Fresh to: <strong>${userCode}</strong>`);
        closeHeaderPopover();
      } 
      else if (isShipping) {
        savePreference('DELIVERY', userCode, 'service-ship', `Shipping Freeze Items to: <strong>${userCode}</strong>`);
        closeHeaderPopover();
      } 
      else {
        if(headerMessage) headerMessage.innerText = "Not available";
      }
  }

  function closeHeaderPopover() {
      if(headerPopover) headerPopover.classList.remove('is-open');
      if(headerInput) headerInput.value = '';
  }

  // =========================================================
  // 6. MODAL LOGIC (ONE-TIME DISPLAY)
  // =========================================================
  
  const modalBackdrop = document.getElementById('dc-modal-backdrop');
  const modalCloseBtn = document.getElementById('dc-modal-close');
  const modalCheckBtn = document.getElementById('modalDeliveryCheckBtn');
  const modalPickupBtn = document.getElementById('modalPickupBtn');
  const modalInput = document.getElementById('modalDeliveryPostcode');
  const modalMessage = document.getElementById('modalDeliveryMessage');
  
  // Check if modal should be shown
  function checkAndShowModal() {
    // Only proceed if modal exists on this page
    if (!modalBackdrop) return;
    
    // Check localStorage for two conditions:
    // 1. Has user already set a preference? (dc_preference)
    // 2. Has user dismissed the modal? (dc_modal_dismissed)
    const hasPreference = localStorage.getItem('dc_preference');
    const hasDismissed = localStorage.getItem('dc_modal_dismissed');
    
    // Only show modal if BOTH are false (first visit/no interaction)
    if (!hasPreference && !hasDismissed) {
      // Small delay for better UX
      setTimeout(() => {
        modalBackdrop.classList.add('is-visible');
      }, 3000); // 3s delay
    }
  }
  
  // Close modal function
  function closeModal() {
    if (modalBackdrop) {
      modalBackdrop.classList.remove('is-visible');
      
      // Mark as dismissed so it doesn't show again this session
      localStorage.setItem('dc_modal_dismissed', 'true');
    }
  }
  
  // Modal Close Button
  if (modalCloseBtn) {
    modalCloseBtn.addEventListener('click', closeModal);
  }
  
  // Close modal when clicking backdrop (outside modal)
  if (modalBackdrop) {
    modalBackdrop.addEventListener('click', function(e) {
      if (e.target === modalBackdrop) {
        closeModal();
      }
    });
    
    // Prevent clicks inside modal from closing it
    const modalContent = modalBackdrop.querySelector('.dc-modal');
    if (modalContent) {
      modalContent.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }
  }
  
  // ESC key to close modal
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modalBackdrop && modalBackdrop.classList.contains('is-visible')) {
      closeModal();
    }
  });
  
  // Modal: Check Delivery
  if (modalCheckBtn) {
    modalCheckBtn.addEventListener('click', function() {
      const userCode = modalInput.value.trim();
      const notifyContainer = document.getElementById('dc-modal-notification-container');
      
      // Reset UI
      if (notifyContainer) notifyContainer.style.display = 'none';
      if (modalMessage) modalMessage.innerText = '';
      
      if (!userCode) {
        if (modalMessage) {
          modalMessage.innerText = "Please enter a postcode.";
          modalMessage.style.color = "red";
        }
        return;
      }
      
      const isLocal = localPostcodes.includes(userCode);
      const isShipping = shippingPostcodes.includes(userCode);
      
      if (isLocal && isShipping) {
        // Both Fresh/Local AND Freeze/Ship available
        savePreference('DELIVERY', userCode, 'service-both', `Fresh & Frozen available to: <strong>${userCode}</strong>`);
        closeModal();
      }
      else if (isLocal) {
        // Fresh / Local only
        savePreference('DELIVERY', userCode, 'service-local', `Delivering Fresh to: <strong>${userCode}</strong>`);
        closeModal();
      } 
      else if (isShipping) {
        // Freeze / Ship only
        savePreference('DELIVERY', userCode, 'service-ship', `Shipping Freeze Items to: <strong>${userCode}</strong>`);
        closeModal();
      } 
      else {
        if (modalMessage) {
          modalMessage.innerText = "Sorry, we don't deliver to this postcode.";
          modalMessage.style.color = "#c62828";
        }
        
        // Show notification form
        if (notifyContainer) {
          notifyContainer.style.display = 'block';
          const bodyInput = notifyContainer.querySelector('#ContactForm-body');
          if (bodyInput) {
            bodyInput.value = `Notify me when delivery is available for postcode: ${userCode}`;
          }
        }
      }
    });
  }
  
  // Modal: Pickup Button
  if (modalPickupBtn) {
    modalPickupBtn.addEventListener('click', function() {
      savePreference('PICKUP', 'PICKUP', 'RESET', `Viewing Menu for: <strong>Store Pickup</strong>`);
      closeModal(); // Close modal on success
    });
  }
  
  // Modal: Enter key support
  if (modalInput) {
    modalInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && modalCheckBtn) {
        modalCheckBtn.click();
      }
    });
  }
  
  // =========================================================
  // 7. ZAPIET INTEGRATION (Auto-fill postcode)
  // =========================================================
  
  function syncWithZapiet(data) {
    // Only sync if it's a delivery postcode (not pickup)
    if (!data || data.type !== 'DELIVERY' || !data.value) return;
    
    // Find Zapiet's postcode input field
    const zapietInput = document.getElementById('deliveryGeoSearchField');
    
    if (zapietInput && zapietInput.value !== data.value) {
      // Set the value
      zapietInput.value = data.value;
      
      // Trigger events that Zapiet might be listening for
      // This ensures their validation/search triggers properly
      zapietInput.dispatchEvent(new Event('input', { bubbles: true }));
      zapietInput.dispatchEvent(new Event('change', { bubbles: true }));
      
      // Focus the input to activate it
      zapietInput.focus();
      
      // Small delay before dispatching blur and clicking
      setTimeout(() => {
        zapietInput.dispatchEvent(new Event('blur', { bubbles: true }));
        
        // Click Zapiet's search/submit button twice (some forms need double-click)
        const zapietButton = document.querySelector('div[role="button"][aria-label="Submit Button"].button.snize-exclude-input');
        if (zapietButton) {
          // First click
          zapietButton.click();
          
          // Second click after a short delay
          setTimeout(() => {
            zapietButton.click();
          }, 200);
        }
      }, 100);
    }
  }
  
  // Sync on page load if preference exists
  const savedData = localStorage.getItem('dc_preference');
  if (savedData) {
    const data = JSON.parse(savedData);
    syncWithZapiet(data);
  }
  
  // Monitor for Zapiet field appearing (for dynamically loaded carts)
  const zapietObserver = new MutationObserver(function(mutations) {
    const zapietInput = document.getElementById('deliveryGeoSearchField');
    if (zapietInput && savedData) {
      const data = JSON.parse(savedData);
      syncWithZapiet(data);
      // Stop observing once we've synced
      zapietObserver.disconnect();
    }
  });
  
  // Start observing document for Zapiet field
  zapietObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Clean up observer after 10 seconds to prevent memory leaks
  setTimeout(() => zapietObserver.disconnect(), 10000);

  // Initialize modal check (run after DOM is ready)
  checkAndShowModal();

  // =========================================================
  // 8. LISTEN FOR EXTERNAL PREFERENCE CHANGES
  // =========================================================
  
  // Listen for preference changes from other components (e.g., menu checker)
  window.addEventListener('dcPreferenceChanged', function(e) {
    const data = e.detail;
    if (data) {
      // Update UI with new preference
      applyUIState('STATUS', data);
      runFilter(data.tag);
      syncWithZapiet(data);
    } else {
      // Preference cleared
      applyUIState('FORM');
      runFilter('RESET');
    }
  });
  
  // Listen for storage changes from other tabs
  window.addEventListener('storage', function(e) {
    if (e.key === 'dc_preference') {
      if (e.newValue) {
        const data = JSON.parse(e.newValue);
        applyUIState('STATUS', data);
        runFilter(data.tag);
        syncWithZapiet(data);
      } else {
        applyUIState('FORM');
        runFilter('RESET');
      }
    }
  });

});